module.exports = __webpack_public_path__ + "static/img/39298.134c87f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/39298.jpg
// module id = SunQ
// module chunks = 0